import {CrudService} from '@ngx-ivengi/crud';
import {Report} from './report.model';
import {Injectable} from '@angular/core';

@Injectable()
export class ReportService extends CrudService<Report> {
  public entityType = Report;
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/report/report.service.ts